import { Stack } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';

import { ReceivingMethod } from '../../../../api/def_common_api';
import { Switch } from '../../../../ui/checkout/Switch/Switch';

import styles from './MethodReceiving.module.sass';

interface ISwitches {
  tab: boolean;
  toggleSwitch: (type: ReceivingMethod) => void;
  setTab: (tab: boolean) => void;
}

const Switches: FC<ISwitches> = ({ tab, toggleSwitch, setTab }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      className={styles.switchWrapper}
    >
      <p
        className={cn(styles.selfDelivery, {
          [styles.active]: !tab,
          [styles.disabled]: tab,
        })}
        onClick={() => toggleSwitch(ReceivingMethod.SelfDelivery)}
      >
        Самовывоз
      </p>
      <Switch tab={tab} onChange={setTab} />
      <p
        className={cn(styles.delivery, {
          [styles.active]: tab,
          [styles.disabled]: !tab,
        })}
        onClick={() => toggleSwitch(ReceivingMethod.Delivery)}
      >
        Доставка
      </p>
    </Stack>
  );
};

export default Switches;
